import * as React from "react";
import "./FlagIcon.scss";
export const FlagIcon = ({ code, size }) => {
    return (React.createElement("span", { className: "fi fi-" + code + (size === "2x" ? " x2" : "") }));
};
